export default {"src":"/pro/_next/static/media/fil.432e1640.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};